// extracted by mini-css-extract-plugin
export default {"header":"style_header__1+S5-","eyebrow":"style_eyebrow__lOTXy","copy":"style_copy__t369q","title":"style_title__Eh2ha","subtitle":"style_subtitle__yxVgr"};